import { PlatformAppEventEmitter } from '@wix/public-editor-platform-events';
import { WithPromiseFunctions } from '@wix/editor-platform-transport';
import {
  createEditorPlatformContextError,
  EditorPlatformContextErrorCode,
} from '../errors';
import { ContextInjectionStatus } from './ContextInjectionStatus';

export type IPrivateAPIFixMe = any; // TODO: replace with the real type

export const ENVIRONMENT_CONTEXT_KEY = '__ENVIRONMENT_CONTEXT_KEY';

declare global {
  // eslint-disable-next-line no-var
  var __ENVIRONMENT_CONTEXT_KEY: EnvironmentContext;
}

export enum PlatformEnvironment {
  Worker = 'Worker',
  Frame = 'Frame',
  // TODO - rename to MainThread
  ComponentPanel = 'ComponentPanel',
}

export interface IEnvironmentContext {
  environment: PlatformEnvironment;
  privateApi: WithPromiseFunctions<IPrivateAPIFixMe>;
  events: PlatformAppEventEmitter;
  /**
   * Probably, we need to rename this prop
   */
  applicationAPIs?: Record<string, any>;
}

export class EnvironmentContext {
  private static status = new ContextInjectionStatus('environment');

  static async inject(context: IEnvironmentContext) {
    if (globalThis[ENVIRONMENT_CONTEXT_KEY]) {
      throw createEditorPlatformContextError(
        EditorPlatformContextErrorCode.IncorrectEnvironment,
        'Environment context already exists and should not be overridden',
      );
    }

    globalThis[ENVIRONMENT_CONTEXT_KEY] = new EnvironmentContext(context);
    this.status.resolveInjected();
  }

  static async getInstance(): Promise<EnvironmentContext> {
    await this.status.waitInjected();
    return globalThis[ENVIRONMENT_CONTEXT_KEY];
  }

  constructor(private environmentContext: IEnvironmentContext) {}

  getPrivateAPI() {
    return this.environmentContext.privateApi;
  }

  getEvents() {
    return this.environmentContext.events;
  }

  getApplicationAPIs() {
    return this.environmentContext.applicationAPIs ?? {};
  }

  getEnvironment() {
    return this.environmentContext.environment;
  }
}
